import { Component, EventEmitter, Input, Output, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from "@angular/forms";

@Component({
   // eslint-disable-next-line @angular-eslint/component-selector
   selector: "telenet-radio-button",
   templateUrl: "./telenet-radio-button.component.html",
   styleUrls: ["./telenet-radio-button.component.scss"],
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => TelenetRadioButtonComponent)
      }
   ],
   imports: [FormsModule]
})
export class TelenetRadioButtonComponent implements ControlValueAccessor {
   @Input() public disabled = false;
   @Input() public value?: string | any;

   @Input() public ngModel: boolean | any | undefined;
   @Output() public ngModelChange = new EventEmitter<
      boolean | any | undefined
   >();

   public onModelChange(checked: any): void {
      this.ngModel = checked;
      this.ngModelChange.emit(checked);
   }

   // Copy pasta delicious for no errors
   onChange: any = () => {};
   onTouch: any = () => {};
   registerOnChange(fn: any): void {
      this.onChange = fn;
   }
   registerOnTouched(fn: any): void {
      this.onTouch = fn;
   }

   checked: boolean = false;
   writeValue(checked: boolean) {
      this.checked = checked;
   }
}
